import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import InfoSections from './components/InfoSections';
import ComparisonSection from './components/ComparisonSection';
import GuidesSection from './components/GuidesSection';
import SafetyAndCta from './components/SafetyAndCta';
import { useJsonLd } from '@/hooks/useJsonLd';
import { SITE_URL, SITE_NAME, FAVICON_URL } from '@/lib/site';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: `${SITE_URL}/`,
      name: SITE_NAME,
      inLanguage: ['en', 'pl', 'es', 'fr'],
    },
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: SITE_NAME,
      url: `${SITE_URL}/`,
      logo: {
        '@type': 'ImageObject',
        url: FAVICON_URL,
      },
    },
  ],
};

export default function Home() {
  useJsonLd(homeSchema);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <InfoSections />
        <ComparisonSection />
        <GuidesSection />
        <SafetyAndCta />
      </main>
      <Footer />
    </div>
  );
}